module.exports = __webpack_public_path__ + "img/icon3.1d4ca92f.png";